<template>
    <div class="main">
        <h2> Правила игры</h2>
        <p class="text_rules">В начале игры Вам будет загадано произвольное рускоязычное имя на кирилице. Игрок предлагает букву, которая может входить в это имя. Если такая буква есть в этом слове, то она будет указана над соответствующими этой букве чертами — столько раз, сколько она встречается в слове. Если такой буквы нет, то к виселице добавляется круг в петле, изображающий голову. Затем игрок продолжает отгадывать буквы до тех пор, пока не отгадает всё имя. За каждый неправильный ответ будет добавляться одна часть туловища к виселице (всего их 6: голова, туловище, 2 руки и 2 ноги).
        Если туловище в виселице нарисовано полностью, то игрок проигрывает и считается повешенным. Если
        игроку удаётся угадать слово, он выигрывает</p>
    </div>
</template>

<script lang="ts" setup>

</script>

<style lang="sass" scoped>
@import '../assets/styles/main'

.text_rules
    font-size: 17px
</style>
